import { ThemeProvider } from "styled-components";
import { AppRoutes } from "./routes";
import theme, { FontsImport } from "./styles/theme";
import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EditProfileProvider } from "./contexts/edit-profile-context";
// import useUserStore from "./store/user";
// import { useEffect } from "react";
// import packageJson from "../package.json";

function App() {
  // const { clearUser } = useUserStore();

  // const clearLocalStorage = () => {
  //   // Salva os valores das chaves antes de limpar o localStorage
  //   const permissionStorage = localStorage.getItem("permission-storage");
  //   const adsVersion = localStorage.getItem("ADS_VERSION");
  //   localStorage.clear(); // Limpa o localStorage
  //   clearUser(); //limpa o store de permissões
  //   // Armazena a versão do package.json
  //   if (adsVersion) {
  //     localStorage.setItem("ADS_VERSION", adsVersion);
  //   }

  //   if (permissionStorage) {
  //     localStorage.setItem("permission-storage", permissionStorage);
  //   }
  // };
  // const clearCookiesAndLocalStorage = () => {
  //   const cookies = document.cookie.split("; ");
  //   cookies.forEach((cookie) => {
  //     const [name] = cookie.split("=");
  //     document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  //   });

  //   clearLocalStorage();
  //   window.location.reload();
  // };

  // useEffect(() => {
  //   initLocalStorage();
  // }, []);

  // const initLocalStorage = () => {
  //   const adsVersion = localStorage.getItem("ADS_VERSION");
  //   if (adsVersion !== packageJson.version) {
  //     clearCookiesAndLocalStorage();
  //     localStorage.setItem("ADS_VERSION", packageJson.version);
  //   }
  // };
  return (
    <>
      <title>{"Georanking"}</title>
      <ToastContainer
        hideProgressBar={true}
        theme="light"
        position="top-right"
        transition={Slide}
      />
      <ThemeProvider theme={theme}>
        <FontsImport />
        <EditProfileProvider>
          <AppRoutes />
        </EditProfileProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
